// extracted by mini-css-extract-plugin
module.exports = {"CloseButton":"CloseButton_CloseButton__kiVLC","CloseButtonPersist":"CloseButton_CloseButtonPersist__KVJ8I","CloseButtonContainer":"CloseButton_CloseButtonContainer__1Tgbf"};